import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { isMobile, isTablet } from 'react-device-detect';
import styles from './about.css';

class About extends Component {
  constructor(props) {
    super(props);
    this.state = {
      x: 0,
      y: 0,
    };
  }

  componentDidMount() {
    const { initialX, initialY } = this.props;

    this.setState({ x: initialX, y: initialY });
  }

  handleKeyDown = e => {
    if (e.keyCode === 27 || e.keyCode === 9) {
      this.props.action(false);
    }
  };

  handleClick = () => {
    this.props.action(false);
  };

  handleMouseMove = e => {
    this.setState({ x: e.pageX, y: e.pageY });
  };

  render() {
    const { x, y } = this.state;

    const isTouch = isMobile || isTablet;

    const style = {
      '--mouse-position': `${x}px, ${y}px`,
    };

    return (
      <div
        onMouseMove={(!isTouch && this.handleMouseMove) || null}
        className={`${styles.wrapper} ${
          isTouch ? styles.touch : ''
        }`}>
        {isTouch && (
          <button
            onClick={this.handleClick}
            className={styles.mobileClose}>
            CLOSE [X]
          </button>
        )}
        <div
          onKeyDown={this.handleKeyDown}
          onClick={(!isTouch && this.handleClick) || null}
          style={(!isTouch && style) || null}
          role="none"
          className={!isTouch ? styles.circle : styles.mobileWindow}>
          <div className={styles.content}>
            <h2 className={styles.heading}>
              {this.props.data.aboutStatement.heading}
            </h2>
            <p className={styles.text}>
              {this.props.data.aboutStatement.text}
            </p>
            <div className={styles.testimonial}>
              <span className={styles.quote}>
                “World’s best website!”
              </span>
              <span className={styles.attribution}>
                —Anonymous art director
              </span>
            </div>
            <div className={styles.credit}>
              <span className={styles.creditText}>
                From the loving art directors at
              </span>
              <span className={styles.ups}>Upstatement</span>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

About.propTypes = {
  data: PropTypes.any,
  action: PropTypes.func,
  initialX: PropTypes.number,
  initialY: PropTypes.number,
};

export default About;
